module.exports = __webpack_public_path__ + "media/icons/pro-5c6739b7.svg";